import * as React from 'react';
import { observer } from 'mobx-react';
import { isGetStartedInSideBySideState } from '../selectors/isGetStartedInSideBySideState';
import { getPendingGetStartedTaskCount } from '../selectors/getPendingGetStartedTaskCount';
import { getGetStartedTaskProperties } from '../utils/getGetStartedTaskProperties';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';
import { GetStartedListProperty } from '../interfaces/GetStartedListProperty';
import { GetStartedListState } from '../interfaces/GetStartedListState';
import GetStartedTask from './GetStartedTask';
import CompletionScreen from './CompletionScreen';
import GetStartedHeader from './GetStartedHeader';
import TaskTallyBanner from './TaskTallyBanner';
import closeGetStartedInListView from '../actions/closeGetStartedInListView';

const styles = require('./GetStartedList.scss');
const classNames = require('classnames');

@observer
export default class GetStartedList extends React.Component<
    GetStartedListProperty,
    GetStartedListState
> {
    constructor(props) {
        super(props);
        this.state = {
            hideAllTasks: props.position === GetStartedListPosition.QuickOption,
            hideCompletedTask: true,
        };
    }

    render() {
        return (
            <div className={classNames(styles.getStartedWrapper, styles.getStartedWrapperColor)}>
                <div className={this.props.className}>
                    <GetStartedHeader
                        position={this.props.position}
                        onChevronButtonClicked={this.toggleTaskListVisibility}
                        onCloseButtonClicked={closeGetStartedInListView}
                    />
                    {!this.state.hideAllTasks && (
                        <div
                            className={
                                isGetStartedInSideBySideState(this.props.position)
                                    ? styles.listViewSingleLineView
                                    : styles.listViewThreeColumnView
                            }>
                            <TaskTallyBanner
                                position={this.props.position}
                                onClick={this.toggleCompletedTaskVisibility}
                            />
                            {getGetStartedTaskProperties().map(taskProps => (
                                <GetStartedTask
                                    key={taskProps.identity}
                                    {...taskProps}
                                    listPosition={this.props.position}
                                    hideCompleted={this.state.hideCompletedTask}
                                />
                            ))}
                        </div>
                    )}
                    {this.props.position === GetStartedListPosition.ListView &&
                        getPendingGetStartedTaskCount() == 0 && <CompletionScreen />}
                </div>
            </div>
        );
    }

    private toggleTaskListVisibility = (evt: React.MouseEvent<unknown>) => {
        this.setState({
            hideAllTasks: !this.state.hideAllTasks,
            hideCompletedTask: this.state.hideCompletedTask,
        });
    };

    private toggleCompletedTaskVisibility = (evt: React.MouseEvent<unknown>) => {
        this.setState({
            hideAllTasks: this.state.hideAllTasks,
            hideCompletedTask: !this.state.hideCompletedTask,
        });
    };
}
